import { isRecordLike } from '../../../../helpers';
import type { FeatureMetadata } from '../../types';

export const isFeatureMetadata = (value: unknown): value is FeatureMetadata => {
    // eslint-disable-next-line
    return (
        isRecordLike(value) &&
        isRecordLike(value.registry)
    );
};
